/* unplugin-vue-components disabled */import script from "./standard.vue?vue&type=script&lang=ts&setup=true"
export * from "./standard.vue?vue&type=script&lang=ts&setup=true"

import "./standard.vue?vue&type=style&index=0&id=1576b81b&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1576b81b"]])

export default __exports__